'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgUploadController', sgUploadController);

  sgUploadController.$inject = ['$scope', '$document', '$element', '$attrs', 'FileUploader', 'UploadService'];

  function sgUploadController ($scope, $document, $element, $attrs, FileUploader, UploadService) {
    const vm = this;
    vm.endpoint = vm.endpoint || 'api/upload';

    vm.acceptedFiles = vm.accepted || 'image/jpg,image/jpeg,image/png,image/gif';
    vm.filesAllowed = true;
    /**
     * Note to future self / warning to other devs:
     * Declaring vm.uploader in vm.$onInit will lead to issues due to vm.uploader being used in template:
     * <div class="sg-upload-dropzone" nv-file-drop nv-file-over uploader="vm.uploader">...</div>
     * At the moment it is being rendered, onInit has not yet finished
     * */
    vm.$onInit = () => {
      vm.init();
      // notify caller of existing files when initialized
      vm.filesChanged(true);
    };

    vm.init = function () {
      /**
      Due to a bug in 'angular-file-upload' the nv-file-over class isn't removed.
      We do this manually by removing the nv-file-over class when the file has left
      the dropzone. The 'vm.counter' keeps track of the difference of dragenters
      and dragends (because dragenters also fire on children). If the counter is
      zero we know that the dragged file is out of the dropzone.
      */
      vm.counter = 0;

      vm.existingUploads = vm.uploadedFiles || [];
      vm.uploader.clearQueue();
      vm.files = {
        add: [], // adding new files.
        remove: [] // remove existing files
      };
    };

    vm.ignoreInternalUpdate = true;
    $scope.$watch('vm.uploadedFiles', function (x, y, z) {
      if (!vm.ignoreInternalUpdate) {
        vm.init();
      }
      vm.ignoreInternalUpdate = false;
    });

    vm.uploader = new FileUploader({
      url: vm.endpoint
    });

    vm.dropzoneElement = $element[0].querySelector('.sg-upload-dropzone');

    vm.dropzoneElement.addEventListener('dragleave', () => {
      vm.counter--;

      if (vm.counter === 0) {
        vm.removeDropzoneMarker();
      }
    });

    vm.dropzoneElement.addEventListener('dragenter', () => {
      vm.counter++;
    });

    vm.removeDropzoneMarker = function () {
      vm.dropzoneElement.classList.remove('nv-file-over');
    };

    // opens the file browser when the upload link is clicked
    vm.openFileBrowser = function () {
      $element[0].querySelector('.native-upload-button').click();
    };

    // deletes a temporary file from the server if the cross icon is clicked
    vm.removeFile = function (file) {
      // ignore errors. Stale files will be deleted in 10 days (TMP folder).
      UploadService.delete({id: file.id}).$promise.then(() => {});

      vm.files.add = vm.files.add.filter( (f) => file.id !== f.id);
      file.remove(); // deletes the file from the ui
      vm.filesChanged();
    };

    // updates list of files
    vm.filesChanged = function (initial = false) {
      const added = vm.files.add.map((upload) => ({
        temporaryFilename: upload.id,
        file: {
          name: upload.file.name,
          type: upload.file.type,
          size: upload.file.size
        }
      }));

      // let parent know that the files have changed
      const filesChangedCallback = vm.filesChangedCb;
      const allFiles = vm.existingUploads.concat(added);

      vm.ignoreInternalUpdate = true;
      filesChangedCallback({ allFiles, initial });
    };

    vm.uploader.onAfterAddingFile = function (addedFile) {
      vm.counter = 0;
      vm.removeDropzoneMarker();
      vm.uploader.uploadItem(addedFile);
      vm.filesAllowed = true;
    };

    vm.uploader.onSuccessItem = function (file, response) {
      // response.fileId contains the temporary id of the uploaded file
      file.id = response.fileId;
      vm.files.add.push(file);

      vm.filesChanged();
    };

    vm.removeExistingFile = function () {
      // md-chips directive removes the existing upload from the list
      vm.filesChanged();
    };

    vm.checkFile = (meta) => vm.acceptedFiles.split(',').indexOf(meta.type) > -1;

  }
})();
